import React from 'react'
import HomeCourses from './HomeCourses'
import Certifications from './Certifications'

function Courses() {
  return (
    <>
      <HomeCourses />
      <Certifications />
    </>
  )
}

export default Courses